 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		6: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		6: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"1bfc9850","1":"777cf710","2":"8371e12b5f4e12e366950a58357a1bc5b982cbc0","3":"styles","4":"6a5b63beb3a7c47127250282894c4955f6a45e81","5":"357c8f200313c55e486537d4bdec0fcd0918b3e3","9":"component---node-modules-gatsby-plugin-offline-app-shell-js","10":"component---src-pages-404-js","11":"component---src-pages-ai-js","12":"component---src-pages-blog-js","13":"component---src-pages-cozumler-enerji-yonetim-sistemi-js","14":"component---src-pages-cozumler-js","15":"component---src-pages-cozumler-toplam-ekipman-verimliligi-js","16":"component---src-pages-cozumler-uretim-izleme-sistemi-js","17":"component---src-pages-cozumler-yapay-zeka-destekli-uretim-js","18":"component---src-pages-demo-js","19":"component---src-pages-iletisim-js","20":"component---src-pages-index-js","21":"component---src-pages-kobigel-js","22":"component---src-pages-moduller-izleme-ve-analiz-gercek-zamanli-izleme-js","23":"component---src-pages-moduller-izleme-ve-analiz-raporlama-servisleri-js","24":"component---src-pages-moduller-izleme-ve-analiz-veri-analizi-js","25":"component---src-pages-moduller-js","26":"component---src-pages-moduller-kullanici-arayuzu-rest-api-js","27":"component---src-pages-moduller-kullanici-arayuzu-web-js","28":"component---src-pages-moduller-uretim-zekasi-istatistiksel-proses-kontrolu-js","29":"component---src-pages-moduller-uretim-zekasi-makine-ogrenimi-js","30":"component---src-pages-moduller-uretim-zekasi-proses-analizi-js","31":"component---src-pages-moduller-uretim-zekasi-proses-optimizasyonu-js","32":"component---src-pages-moduller-veri-ve-kontrol-gecmise-donuk-veri-kaydi-hizmeti-js","33":"component---src-pages-moduller-veri-ve-kontrol-nesnelerin-interneti-iot-js","34":"component---src-pages-moduller-veri-ve-kontrol-veri-toplama-servisleri-js","35":"component---src-pages-moduller-yonetim-bakim-ve-servis-yonetimi-js","36":"component---src-pages-moduller-yonetim-ekipman-yonetimi-ve-oee-js","37":"component---src-pages-moduller-yonetim-enerji-yonetimi-js","38":"component---src-pages-moduller-yonetim-gorev-yonetimi-js","39":"component---src-pages-moduller-yonetim-is-emri-planlamasi-js","40":"component---src-pages-moduller-yonetim-kalite-yonetimi-js","41":"component---src-pages-moduller-yonetim-kullanici-yonetimi-js","42":"component---src-pages-moduller-yonetim-kural-ve-bildirim-yonetimi-js","43":"component---src-pages-moduller-yonetim-recete-yonetimi-js","44":"component---src-pages-moduller-yonetim-tuketim-yonetimi-js","45":"component---src-pages-rehber-js","46":"component---src-pages-retmes-hakkinda-js","47":"component---src-pages-success-js","48":"component---src-templates-blog-template-js","49":"component---src-templates-default-template-js"}[chunkId]||chunkId) + "-" + {"0":"eadf3c071c5440605dbb","1":"7df4cff8823f19a3d8fb","2":"0825fc9a1cdff728ebbf","3":"8d3db5124725dcff78a7","4":"3757b8b010c55b27a888","5":"de2021cbcda2c1b95828","9":"23c89527473179875695","10":"12f7ffc530bf487d73cd","11":"a6776e79bd6e73699983","12":"b276883b6bf680e5e622","13":"2c36c45000ac7fe36bef","14":"61e5c5ca2e30f1ef4dc6","15":"99e3b2e130d08456a55f","16":"d38076e4e304ae186612","17":"e0ad333ac3f031879448","18":"db913356897a5a262823","19":"86123a9b3f22ff6b4697","20":"b539ad59295776051864","21":"1a5fe3dad98155cbfcac","22":"1b1a4ee6ccdfb2d5c686","23":"564395e262da1886d188","24":"8771bf44a96238c37fe8","25":"99fde5e0ea5b4e5df041","26":"ea7b63ad44e4f53e1ff7","27":"b04502d45087cf5527db","28":"613ba4a87d454f45f917","29":"6b2dbfcaa73ac2ef77e9","30":"18df8bde6864f7186d6f","31":"1422b135f5ad85371cee","32":"0103b87964102335b600","33":"d45e992c12e2330b1869","34":"eaef0b9a75d02952bd48","35":"11772399e39425a6f4ba","36":"b81d6268d2509b92ee16","37":"1a5d898714e71908a245","38":"f382551e8e1f57076d72","39":"9ab7e13713b5fa3501cf","40":"cb0fc243789f3b563b7d","41":"c803945aa10f7012fe1e","42":"80c0e3f394e9def9823f","43":"6b8df30eb24734f1b233","44":"f81995bdaf3aaa424610","45":"4906a4838ec44f1ee4e9","46":"8e4a7f0cdd18fe8c161f","47":"a58fcaf2a36d5cb3f178","48":"ab27a99cd3b4e25c3a36","49":"a37bad579455ccaea8bf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"1bfc9850","1":"777cf710","2":"8371e12b5f4e12e366950a58357a1bc5b982cbc0","3":"styles","4":"6a5b63beb3a7c47127250282894c4955f6a45e81","5":"357c8f200313c55e486537d4bdec0fcd0918b3e3","9":"component---node-modules-gatsby-plugin-offline-app-shell-js","10":"component---src-pages-404-js","11":"component---src-pages-ai-js","12":"component---src-pages-blog-js","13":"component---src-pages-cozumler-enerji-yonetim-sistemi-js","14":"component---src-pages-cozumler-js","15":"component---src-pages-cozumler-toplam-ekipman-verimliligi-js","16":"component---src-pages-cozumler-uretim-izleme-sistemi-js","17":"component---src-pages-cozumler-yapay-zeka-destekli-uretim-js","18":"component---src-pages-demo-js","19":"component---src-pages-iletisim-js","20":"component---src-pages-index-js","21":"component---src-pages-kobigel-js","22":"component---src-pages-moduller-izleme-ve-analiz-gercek-zamanli-izleme-js","23":"component---src-pages-moduller-izleme-ve-analiz-raporlama-servisleri-js","24":"component---src-pages-moduller-izleme-ve-analiz-veri-analizi-js","25":"component---src-pages-moduller-js","26":"component---src-pages-moduller-kullanici-arayuzu-rest-api-js","27":"component---src-pages-moduller-kullanici-arayuzu-web-js","28":"component---src-pages-moduller-uretim-zekasi-istatistiksel-proses-kontrolu-js","29":"component---src-pages-moduller-uretim-zekasi-makine-ogrenimi-js","30":"component---src-pages-moduller-uretim-zekasi-proses-analizi-js","31":"component---src-pages-moduller-uretim-zekasi-proses-optimizasyonu-js","32":"component---src-pages-moduller-veri-ve-kontrol-gecmise-donuk-veri-kaydi-hizmeti-js","33":"component---src-pages-moduller-veri-ve-kontrol-nesnelerin-interneti-iot-js","34":"component---src-pages-moduller-veri-ve-kontrol-veri-toplama-servisleri-js","35":"component---src-pages-moduller-yonetim-bakim-ve-servis-yonetimi-js","36":"component---src-pages-moduller-yonetim-ekipman-yonetimi-ve-oee-js","37":"component---src-pages-moduller-yonetim-enerji-yonetimi-js","38":"component---src-pages-moduller-yonetim-gorev-yonetimi-js","39":"component---src-pages-moduller-yonetim-is-emri-planlamasi-js","40":"component---src-pages-moduller-yonetim-kalite-yonetimi-js","41":"component---src-pages-moduller-yonetim-kullanici-yonetimi-js","42":"component---src-pages-moduller-yonetim-kural-ve-bildirim-yonetimi-js","43":"component---src-pages-moduller-yonetim-recete-yonetimi-js","44":"component---src-pages-moduller-yonetim-tuketim-yonetimi-js","45":"component---src-pages-rehber-js","46":"component---src-pages-retmes-hakkinda-js","47":"component---src-pages-success-js","48":"component---src-templates-blog-template-js","49":"component---src-templates-default-template-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"f170acd8d014df06cd2a","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
